export default __webpack_public_path__ + "static/media/target-icon-green.51e67fb9.svg";